import type { ResAllType } from '../../Types/Api/All'
import type { OKRes } from '../../Types/Api/Ok'
import type { TaxonomyType } from '../../Types/Api/Taxonomy'
import type { SortTermsReq, TermReq, TermType } from '../../Types/Api/Term'
import { api } from './API'
import { requireAuth } from './Auth'

export const findAllTaxonomy = async (name: string) => {
  const res = await requireAuth<ResAllType<TaxonomyType>>(
    api.get('taxonomies', { order_by: 'asc', site_name: name }),
  )

  if (res.ok) {
    return res.data
  }

  return []
}

export const findTerm = (id: number, postTypeName: string, name: string) => {
  return requireAuth<TermType>(
    api.get(`terms/${id}`, { post_type_name: postTypeName, site_name: name }),
  )
}

export const findAllTerms = (taxonomy_ids: number[], name: string) => {
  return requireAuth<TermType[]>(
    api.get('terms', {
      taxonomy_ids,
      query_type: 'all',
      orderBy: 'name:asc',
      site_name: name,
    }),
  )
}

export const findAllRootTerm = (taxonomy_id: number, name) => {
  return requireAuth<ResAllType<TermType>>(
    api.get('root_terms', {
      taxonomy_id,
      orderBy: 'name:asc',
      site_name: name,
    }),
  )
}

export const searchTerms = (
  taxonomy_id: number,
  name: string,
  search_conditions: { name: string } | null = null,
) => {
  const conditionParams = search_conditions
    ? JSON.stringify(search_conditions)
    : null
  return requireAuth<TermType[]>(
    api.get('terms', {
      taxonomy_id,
      query_type: 'search',
      site_name: name,
      conditionParams: conditionParams,
    }),
  )
}

export const createTerm = (values: FormData | TermReq, name: string) => {
  return requireAuth<TermType>(api.post(`terms?site_name=${name}`, values))
}

export const updateTerm = (
  id: number,
  values: FormData | TermReq,
  name: string,
) => {
  return requireAuth<TermType>(
    api.post(`terms/${id}?site_name=${name}`, values),
  )
}

export const deleteTerm = (
  id: number,
  taxonomy_id: number,
  siteName: string,
  postTypeName: string,
) => {
  return requireAuth<OKRes>(
    api.delete(`terms/${id}`, {
      taxonomy_id,
      site_name: siteName,
      post_type_name: postTypeName,
    }),
  )
}

export const fieldGroupsToTaxonomyFields = (fieldGroups) => {
  return fieldGroups
    .map((fieldGroup) => {
      return fieldGroup.fields.filter(
        (field) => field.input_type === 'taxonomy',
      )
    })
    .reduce((prev, fields) => {
      return [...prev, ...fields]
    }, [])
}

export const sortTerms = (
  site_name: string,
  taxonomy_id: number,
  terms: SortTermsReq[],
) => {
  return requireAuth<OKRes>(
    api.post(`terms/sort/order`, { site_name, taxonomy_id, terms }),
  )
}
